var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "column-layout scroll-bar" }, [
    _c(
      "div",
      { staticClass: "left-column fl" },
      [
        _c("swb-goods-categ-tree", {
          attrs: {
            enableSearch: _vm.enableSearch,
            isClickEvent: _vm.isClickEvent
          },
          on: {
            "notity-change": function($event) {
              _vm.checkGoodsCatChange($event)
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "right-column fl" }, [
      _c(
        "div",
        { staticClass: "switch-list" },
        _vm._l(_vm.catBrandList, function(row) {
          return _c(
            "el-radio-group",
            {
              model: {
                value: _vm.brandId,
                callback: function($$v) {
                  _vm.brandId = $$v
                },
                expression: "brandId"
              }
            },
            [
              _c(
                "div",
                { staticClass: "switch-item" },
                [
                  _c("el-radio", { attrs: { label: row.id } }, [
                    _vm._v(_vm._s(row.brand.name))
                  ])
                ],
                1
              )
            ]
          )
        })
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-523db9c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-523db9c8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/GoodsCategAndBrandSelect.vue
// module id = 3103
// module chunks = 0